<template>
  <FormulateInput
    type="select"
    :name="name"
    :label="label"
    :options="options"
    :validation="validation"
    @input="inputCallback"
    @validation="$emit('validation', $event)"
    v-bind="$attrs"
    v-model="value"
    :readonly="readonly"
    :element-class="[ readonly ? 'select-readonly' : '' ]"
  />
</template>
<script>
export default {
  name: "ComboboxInputComponent",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
      default: "Salvar",
    },
    type: {
      type: String,
    },
    options: {
      type: Object,
    },
    validation: {
      type: String,
    },
    value: {},

    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  
  methods: {
    inputCallback(value){
      this.$emit('input', value)
      this.$emit('update', {
        name: this.name,
        model: value
      })
    }
  }
};
</script>